export default __webpack_public_path__ + "static/media/text-icon.0ac57c6e.svg";